import NDAStatusCard from './NDAStatusCard.component';

export default NDAStatusCard;
